import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Form,
} from "@kitbird/core";
import { FormContainer } from "../../../../../components/Form/Form.style";

interface BankFormProps {
  defaultValue: unknown;
  onSubmit: (value: unknown) => void;
  onClose: () => void;
}

const BankForm = ({ defaultValue, onSubmit }: BankFormProps) => {
  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      bank_code: "",
      bank_desc: "",
      bank_key: "",
      is_active: 1,
    },
  });

  useEffect(() => {
    if (defaultValue) {
      reset({
        ...defaultValue,
      });
    }
  }, [defaultValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormContainer>
        <Controller
          control={control}
          name="bank_code"
          render={({ field }) => (
            <Form
              {...field}
              label="Nama bank"
            />
          )}
        />
        <Controller
          control={control}
          name="bank_desc"
          render={({ field }) => (
            <Form
              {...field}
              label="Deskripsi"
            />
          )}
        />
      </FormContainer>
    </form >
  );
};

export default BankForm;
